import UserPersistence from "../persistence/UserPersistence";
import ArrayUtils from "../libs/utils/ArrayUtils";
import NumberUtils from "../libs/utils/NumberUtils";
// 枚举列表过滤器
function getEnumerationListItem(value, type) {
  if (!value) return '';
  let enumerationList = UserPersistence.getEnumerationList().filter(
    (item) => item.categoryId === type
  );
  let enumerationItem = ArrayUtils.getItemBy(enumerationList, 'id', value.toString());
  return enumerationItem.name;
}
// 金额过滤器
function formatAmount(value) {
  return NumberUtils.formatData(value);
}

export default {
  getEnumerationListItem,
  formatAmount
}



// WEBPACK FOOTER //
// ./src/filters/index.js